"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chipConfig = exports.popoverConfig = exports.statusBarConfigData = exports.imageUrlData = void 0;
const tslib_1 = require("tslib");
const imageUrlData = require("./imageUrl.json");
exports.imageUrlData = imageUrlData;
const statusBarConfigData = require("./statusBarConfig.json");
exports.statusBarConfigData = statusBarConfigData;
const popoverConfig = require("./PopoverConfig.json");
exports.popoverConfig = popoverConfig;
const chipConfig = require("./chipConfig.json");
exports.chipConfig = chipConfig;
tslib_1.__exportStar(require("./badge-map"), exports);
